import { isIngame } from '../external_node_modules/@wg/web2clientapi/utils/checkIngame.js';

function redirectToUrl(url) {
    if (!isIngame()) {
        window.location.href = url;
        return;
    }
}

export { redirectToUrl };
//# sourceMappingURL=redirectToUrl.js.map
